module.exports = __webpack_public_path__ + "img/ydd_hangqing.0213ef28.png";